/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Sitting_OutInputs */



/**
* | output |
* | --- |
* | "Sitting out this round" |
*
* @param {Rounds_Sitting_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_sitting_out = /** @type {((inputs?: Rounds_Sitting_OutInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Sitting_OutInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ne joue pas cette ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descansando esta ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Descansando esta rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("In pausa questo turno")
	return /** @type {LocalizedString} */ ("Sitting out this round")
});